<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">ArchiveReason Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>ArchiveReason Name</td>
                  <td>
                    {{ archiveReasonModel.name ? archiveReasonModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>ArchiveReason Id</td>
                  <td>
                    {{ archiveReasonModel.id ? archiveReasonModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New ArchiveReason</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ArchiveReason } from "@/models/ArchiveReason";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      archiveReasonModel: new ArchiveReason(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "ArchiveReasons",
          disabled: false,
          href: "/admin/archiveReasons",
        },
        {
          text: "ArchiveReason Details",
          disabled: false,
          href: `/admin/archiveReason/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    archiveReason: {
      query: gql`
        query ArchiveReason($id: ID!) {
          archiveReason(id: $id) {
            id
            name
            type
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.archiveReasonModel.id = this.archiveReason.id;
        this.archiveReasonModel.name = this.archiveReason.name;
        this.archiveReasonModel.type = this.archiveReason.type;
        this.archiveReasonModel.createdBy = this.archiveReason.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
